<template>
  <div class="detail-form">
    <Form ref="formData" :key="'sendLeter'+formData.sendType" :model="formData" :rules="ruleValidate" :label-width="100">
      <FormItem label="发函类型" prop="sendType">
        <Select v-model="formData.sendType" transfer placeholder="请选择发函类型" :disabled="defaultData!==''">
          <Option v-for="item in sendTypeArr" :key="item.id" :value="item.value">{{ item.nameZh }}</Option>
        </Select>
      </FormItem>
      <Row v-if="formData.sendType=='E'">
        <FormItem
          label="发函日期"
          prop="sendDate"
          :rules="[{required: true, message: '发函日期不能为空', trigger: 'blur'}]"
        >
          <DatePicker
            transfer
            type="date"
            placeholder="请选择发函日期"
            style="width:100%"
            format="yyyy-MM-dd"
            :value="formData.sendDate"
            @on-change="getValue($event,'sendDate')"
          />
        </FormItem>
        <FormItem
          label="发函内容"
          prop="letterContent"
          :rules="{max:2048, message: '不能超过2048个字符', trigger: 'blur'}"
        >
          <Input v-model.trim="formData.letterContent" type="textarea" :autosize="{minRows: 3,maxRows: 8}" placeholder="请填写发函内容" />
        </FormItem>
        <FormItem
          label="律师函"
          prop="attachmentList"
          :rules="[{ required: true,type:'array', message: '律师函不能为空', trigger: 'blur' }]"
        >
          <file-upload
            v-if="isDetailLoad"
            :default-list="defaultList || []"
            :upload-config="{maxNum:1}"
            @getFileList="getAttachmentList"
          />
        </FormItem>
        <FormItem
          label="发函方式"
          prop="sendWay"
          :rules="[{required: true, message: '发函方式不能为空', trigger: 'blur'}]"
        >
          <Select v-model="formData.sendWay" transfer placeholder="请选择发函方式">
            <Option v-for="item in sendWayArr" :key="item.id" :value="item.value">{{ item.nameZh }}</Option>
          </Select>
        </FormItem>
        <FormItem
          v-if="formData.sendWay=='M'"
          label="收到已读回执"
          prop="emailReturnReceipt"
          :rules="[{required: true,type:'number', message: '已读回执不能为空', trigger: 'blur'}]"
        >
          <RadioGroup v-model="formData.emailReturnReceipt">
            <Radio :label="1">是</Radio>
            <Radio :label="0" :disabled="defaultData!=='' && formData.emailReturnReceipt===1">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem
          v-if="formData.sendWay=='E'"
          label="快递公司"
          prop="expressCompany"
          :rules="[{required: true, message: '快递公司不能为空', trigger: 'blur'}]"
        >
          <Select v-model="formData.expressCompany" transfer placeholder="请选择快递公司">
            <Option v-for="item in courierCompanyArr" :key="item.id" :value="item.value">{{ item.nameZh }}</Option>
          </Select>
        </FormItem>
        <FormItem
          v-if="formData.sendWay=='E'"
          label="快递单号"
          prop="expressNo"
          :rules="[{required: true, message: '快递单号不能为空', trigger: 'blur'},{ max:16,message:'不能超过16个字符',trigger:'blur' }]"
        >
          <Input v-model="formData.expressNo" placeholder="请输入快递单号" />
        </FormItem>
      </Row>
      <Row v-if="formData.sendType=='O'">
        <FormItem
          label="投诉日期"
          prop="complaintsDate"
          :rules="[{required: true, message: '投诉日期不能为空', trigger: 'blur'}]"
        >
          <DatePicker
            type="date"
            transfer
            placeholder="请选择投诉日期"
            style="width:100%"
            format="yyyy-MM-dd"
            :value="formData.complaintsDate"
            @on-change="getValue($event,'complaintsDate')"
          />
        </FormItem>
        <FormItem
          label="投诉平台"
          prop="platform"
          :rules="[{required: true, message: '投诉平台不能为空', trigger: 'blur'}]"
        >
          <Select v-model="formData.platform" transfer placeholder="请选择投诉平台">
            <Option v-for="item in complaintsPlatformArr" :key="item.id" :value="item.value">{{ item.nameZh }}</Option>
          </Select>
        </FormItem>
        <FormItem
          label="投诉网址"
          prop="url"
          :rules="[{required: true, message: '投诉网址不能为空', trigger: 'blur'},{type:'url', message: '投诉网址不正确', trigger: 'blur'}]"
        >
          <Input v-model="formData.url" placeholder="请输入投诉网址" />
        </FormItem>
        <FormItem
          label="投诉内容"
          prop="content"
          :rules="[{required: true, message: '请填写投诉内容', trigger: 'blur'},{ max:200,message:'不能超过200个字符',trigger:'blur'}]"
        >
          <Input v-model.trim="formData.content" type="textarea" :autosize="{minRows: 3,maxRows: 8}" placeholder="请填写投诉内容" />
        </FormItem>
      </Row>
    </Form>
    <Row class="detail-btn-box">
      <Button type="primary" style="margin-right:10px;" :disabled="isSubmit" @click="submitNew">保存</Button>
      <Button @click="$emit('changeEditCtrl',false)">取消</Button>
    </Row>
  </div>
</template>
<script>
export default {
  components: {},
  props: ['processId', 'defaultData', 'caseId'],
  data () {
    return {
      isSubmit: false,
      isDetailLoad: true,
      defaultList: [],
      sendTypeArr: [],
      sendWayArr: [],
      courierCompanyArr: [],
      complaintsPlatformArr: [],
      formData: {
        sendType: 'E',
        sendDate: '',
        letterContent: '',
        attachmentList: [],
        sendWay: 'E',
        emailReturnReceipt: 0,
        expressCompany: '',
        expressNo: '',
        complaintsDate: '',
        url: '',
        platform: 'TT',
        content: ''
      },
      ruleValidate: {
        sendType: [{ required: true, message: '发函类型不能为空', trigger: 'change' }]
      }
    }
  },
  watch: {},
  created() {},
  beforeMount() {
    this.getDictionary()
    if (this.defaultData) {
      this.getDefaultData()
    }
  },
  mounted() {},
  updated() {},
  methods: {
    getAttachmentList(arr) {
      this.formData.attachmentList = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formData.attachmentList.push(obj)
      })
    },
    submitNew() {
      let url = ''
      const ajaxData = {
        processId: this.processId,
        caseId: this.caseId,
        sendType: this.formData.sendType
      }
      if (this.formData.sendType == 'E') {
        url = '/business/case/lawyer-letter'
        ajaxData.sendDate = this.formData.sendDate
        ajaxData.letterContent = this.formData.letterContent
        ajaxData.attachmentList = this.formData.attachmentList
        ajaxData.sendWay = this.formData.sendWay
        if (ajaxData.sendWay == 'M') {
          ajaxData.emailReturnReceipt = this.formData.emailReturnReceipt
        } else {
          ajaxData.expressCompany = this.formData.expressCompany
          ajaxData.expressNo = this.formData.expressNo
        }
      } else if (this.formData.sendType == 'O') {
        url = '/business/case/online-complaint'
        ajaxData.complaintsDate = this.formData.complaintsDate
        ajaxData.platform = this.formData.platform
        ajaxData.url = this.formData.url
        ajaxData.content = this.formData.content
      }

      if (this.defaultData) {
        ajaxData.id = this.defaultData.id
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$patch(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.$Message.success('操作成功')
                this.$emit('changeEditCtrl', true)
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      } else {
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$post(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.$Message.success('操作成功')
                this.$emit('changeEditCtrl', true)
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      }
    },
    getValue(value, key) {
      this.formData[key] = value
    },
    // 赋默认值
    getDefaultData() {
      this.formData.sendType = this.defaultData.sendType || 'E'
      this.formData.sendDate = this.defaultData.sendDateStr || ''
      this.formData.letterContent = this.defaultData.letterContent || ''
      this.formData.sendWay = this.defaultData.sendWay || 'E'
      this.formData.emailReturnReceipt = this.defaultData.emailReturnReceipt ? 1 : 0
      this.formData.expressCompany = this.defaultData.expressCompany || ''
      this.formData.expressNo = this.defaultData.expressNo || ''
      this.formData.complaintsDate = this.defaultData.complaintsDateStr || ''
      this.formData.url = this.defaultData.url || ''
      this.formData.platform = this.defaultData.platform || 'TT'
      this.formData.content = this.defaultData.content || ''

      this.formData.attachmentList = []
      this.defaultList = []
      if (this.defaultData.attachmentList && this.defaultData.attachmentList.length != 0) {
        this.defaultData.attachmentList.forEach((item, index) => {
          const obj = {
            fileName: item.fileName,
            mediaType: item.mediaType,
            smallUrl: item.smallUrl,
            url: item.url
          }
          this.formData.attachmentList.push(obj)
          this.defaultList.push(obj)
        })
      }
    },
    // 数据字典
    async getDictionary() {
      this.sendTypeArr = await this.common.getDictionaryItems('send_type')
      this.sendWayArr = await this.common.getDictionaryItems('send_way')
      this.courierCompanyArr = await this.common.getDictionaryItems('courier_company')
      this.complaintsPlatformArr = await this.common.getDictionaryItems('complaints_platform')
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/view/civilCase/sendLetter/sendLetterForm.vue